if (!customElements.get('pawce-purchase')) {
  const choices = new Map();
  class PawcePurchase extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      this.form = this.closest('form');
      if (!this.form) return;
      this.variants = JSON.parse(this.querySelector('[data-purchase-variants]').textContent);
      this.form.dataset.pawceNativePurchase = 'true';
      const options = { signal: this.controller.signal };
      const remembered = choices.get(this.dataset.formId);
      const fromUrl = new URLSearchParams(location.search).get('selling_plan');
      const wanted = remembered ?? fromUrl;
      const candidate = this.radios.find(input => input.value === wanted);
      if (candidate) candidate.checked = true;
      this.addEventListener('change', () => { choices.set(this.dataset.formId, this.selected?.value || ''); this.sync(); }, options);
      this.form.addEventListener('change', event => { if (event.target.name === 'id') this.updateVariant(); }, options);
      this.form.addEventListener('formdata', event => {
        event.formData.delete('selling_plan');
        if (this.selected?.value) event.formData.set('selling_plan', this.selected.value);
      }, options);
      this.form.addEventListener('submit', () => {
        for (const field of this.form.querySelectorAll('[name="selling_plan"]')) {
          if (!this.contains(field)) field.disabled = true;
        }
      }, { ...options, capture: true });
      this.updateVariant();
    }
    disconnectedCallback() { this.controller?.abort(); }
    get radios() { return Array.from(this.querySelectorAll('input[type="radio"]')); }
    get selected() { return this.radios.find(input => input.checked && !input.disabled); }
    updateVariant() {
      const id = this.form.querySelector('[name="id"]')?.value;
      const variant = this.variants.find(item => String(item.id) === id) || this.variants[0];
      for (const radio of this.radios) {
        const plan = variant.plans.find(item => String(item.id) === radio.value);
        const unavailable = Boolean(radio.value && !plan);
        radio.disabled = unavailable;
        radio.closest('label').hidden = unavailable;
        radio.dataset.price = plan?.price || variant.price;
        const price = radio.closest('label').querySelector('[data-plan-price], [data-once-price]');
        if (price) price.textContent = radio.dataset.price;
        const original = radio.closest('label').querySelector('s');
        if (original) original.textContent = variant.price;
      }
      if (!this.selected) {
        const fallback = this.radios.find(input => !input.disabled && !input.value) || this.radios.find(input => !input.disabled);
        if (fallback) fallback.checked = true;
      }
      this.sync();
    }
    sync() {
      const selected = this.selected;
      if (!selected) return;
      const label = selected.value ? this.dataset.subscribeLabel : this.dataset.onceLabel;
      for (const renewal of this.querySelectorAll('[data-plan-renewal]')) renewal.hidden = !selected.value || !renewal.closest('label').querySelector('input').checked;
      this.querySelector('[data-purchase-summary]').textContent = selected.value ? selected.closest('label').querySelector('[data-plan-renewal]')?.textContent : this.querySelector('.pw-option--once .pw-option__description')?.textContent;
      for (const button of document.querySelectorAll('button[type="submit"][form]')) {
        if (button.getAttribute('form') !== this.dataset.formId || button.disabled) continue;
        const text = button.querySelector('.btn-text > span:last-child');
        if (text) text.textContent = `${label} · ${selected.dataset.price}`;
        button.setAttribute('aria-label', `${label} ${selected.dataset.price}`);
      }
      const section = this.closest('.shopify-section');
      const stickyPrice = section?.querySelector('[id^="StickyPrice-"]');
      if (stickyPrice) stickyPrice.textContent = `${selected.dataset.price} ${selected.value ? 'today' : ''}`.trim();
    }
  }
  customElements.define('pawce-purchase', PawcePurchase);
  document.addEventListener('click', event => {
    const link = event.target.closest('a[href="#pawce-purchase"]');
    if (!link) return;
    const purchase = document.querySelector('[data-pawce-purchase]');
    if (!purchase) return;
    event.preventDefault();
    purchase.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'center' });
    purchase.querySelector('input:checked')?.focus({ preventScroll: true });
    history.replaceState(null, '', '#pawce-purchase');
  });
}

